import React, { useState, useEffect, useMemo } from "react";
import axios from "axios";
import "react-datepicker/dist/react-datepicker.css";
import { useSelector, useDispatch } from "react-redux";
import { Tooltip } from "@mui/material";
import LinkIcon from '@mui/icons-material/Link';
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import { useNavigate } from 'react-router-dom';
import Loader from "./../../CommonLoader";
import DatagridComp from "../../DatagridComp";
import { CommonErrorAlert } from "../../../../Commonalert/commonErrorAlert";

export default function Missingtitle({ datavalue, JobId, SubmitTriggered, SetSubmitTriggered, domainsection, handleModelPopUp, handleDownlodingCSV, handleDownlodingPDF }) {

  const [cardData, setCardData] = useState([]);
  const [missingData, setMissingData] = useState("")
  const [loading, setLoading] = React.useState(false)
  const esodata = useSelector((state) => state);
  const ApiToken = esodata.apiauthkey.value
  const [autoheightval, SetAutoheightval] = useState(true)
  const navigate = useNavigate();
  const [apiopen, setapiOpen] = React.useState(false);
  const [apierrorMsg, setapierrorMsg] = useState();
  const [tableLoading, setTableLoading] = useState(true);


  const apihandleClose = () => {
    setapiOpen(false);
  };
  useEffect(() => {
    callUserdataApi(datavalue);

    if (parseInt(datavalue) === 1) {

      SetColumnTitle('URL of the web page')

    }
    if (parseInt(datavalue) === 2) {

      SetColumnTitle('URL of the web page')
    }
    if (parseInt(datavalue) === 3) {

      SetColumnTitle('URL of the web page')
    }
    if (parseInt(datavalue) === 5) {

      SetColumnTitle('URL of the web page')
    }
    if (parseInt(datavalue) === 10) {

      SetColumnTitle('URL of the web page')
    }
  }, [datavalue]);

  useEffect(() => {

    if (SubmitTriggered === true) {
      callUserdataApi(datavalue)
    }

  }, [SubmitTriggered])
  useEffect(() => {
    callUserdataApi(datavalue)

  }, [domainsection])
  const [ColumnTitle, SetColumnTitle] = useState('')

  const columns = [

    {
      field: "page_url",
      headerName: "Page URL",
      description: ColumnTitle,
      minWidth: 320,
      flex: 1,
      disableClickEventBubbling: true,
      headerAlign: "center",
      align: "center",
      sortable: true,
      renderCell: (cardData) => {

        let baseUrl = cardData.row.page_url.split("/").slice(0, 3).join("/") + "/";
        let remaining = cardData.row.page_url.split("/").slice(3).join("/");

        return (
          <>
            <div className="tooltip-container">
              <div className="prefered_url_external02 tooltip-button">
                <a className="table_links" target="_blank" href={cardData.row.page_url} style={{ display: 'flex', flexDirection: 'column' }} >
                  <span className="spanlink" style={{ color: "#044792" }} >
                    <LinkIcon /> {baseUrl}
                  </span>
                  <span className="spanlink" style={{ color: "#044792", wordWrap: "break-word", wordBreak: "break-word" }}>{remaining}</span>
                </a>
                <span className="tooltip-text">{cardData.row.page_url}</span>
              </div>
            </div>
          </>
        );

      },

    },
  ];

  const rows = cardData ?? [];
  const callUserdataApi = async (missingdatas) => {
    setLoading(true);
    setTableLoading(true);
    setCardData([])
    var dataurls = ""
    if (missingdatas == 1) {
      dataurls = `${process.env.REACT_APP_API_URL}technical/onpagecrawl/?user_domain_id=${esodata.domaindata.value.header_selected}&domain_section_id=${domainsection}&job_id=${JobId}&field_type=missing_title`
    }
    else if (missingdatas == 2) {
      dataurls = `${process.env.REACT_APP_API_URL}technical/onpagecrawl/?user_domain_id=${esodata.domaindata.value.header_selected}&domain_section_id=${domainsection}&job_id=${JobId}&field_type=missing_canonical`
    }
    else if (missingdatas == 3) {
      dataurls = `${process.env.REACT_APP_API_URL}technical/onpagecrawl/?user_domain_id=${esodata.domaindata.value.header_selected}&domain_section_id=${domainsection}&job_id=${JobId}&field_type=missing_description`
    }
    else if (missingdatas == 4) {
      dataurls = `${process.env.REACT_APP_API_URL}technical/onpagecrawl/?user_domain_id=${esodata.domaindata.value.header_selected}&domain_section_id=${domainsection}&job_id=${JobId}&field_type=missing_alt`
    }
    else if (missingdatas == 5) {
      dataurls = `${process.env.REACT_APP_API_URL}technical/onpagecrawl/?user_domain_id=${esodata.domaindata.value.header_selected}&domain_section_id=${domainsection}&job_id=${JobId}&field_type=missing_h1`
    }
    else if (missingdatas == 10) {
      dataurls = `${process.env.REACT_APP_API_URL}technical/onpagecrawl/?user_domain_id=${esodata.domaindata.value.header_selected}&domain_section_id=${domainsection}&job_id=${JobId}&field_type=no_index_robot`
    }
    const datavalue = await axios
      .get(
        `${dataurls}`,
        {
          headers: {
            Authorization: `${ApiToken}`,
          },
        }
      ).catch((error) => {
        if (error?.response?.status == 599 || error?.response?.status == 500 || error?.response?.status == 400 || error?.response?.status == 404) {
          setapiOpen(true);
          setapierrorMsg(error?.response?.data?.error)
        }
        else if (error?.code == "ERR_NETWORK") {
          navigate('/errorpages')
        }
      });
    const dataval = datavalue?.data?.table?.urls


    if (dataval && dataval.length > 0) {
      const newData = dataval.map((obj, index) => {
        return { ...obj, sid: index + 1 };
      });
      setCardData(newData);
      SetAutoheightval(false)
    }
    else {
      setCardData("");
      SetAutoheightval(true)
    }

    setTableLoading(false);
    setLoading(false)
    SetSubmitTriggered(false)
  };

  return (
    <>
      {loading === true ? <Loader /> : null}
      <div
        style={{
          width: "calc(100% - 40px)",
          marginRight: "40px",
          marginLeft: "auto",
          marginRight: "auto",
        }}
      >
        <div className="data_table internal_source_table internal_outsource_table" style={{ width: "100%" }}>
          <DatagridComp
            columns={columns}
            rows={rows}
            autoheightval={autoheightval}
            datagridval={2}
            columnFreezeWidth={[0]}
            tableLoading={tableLoading}
            handleModelPopUp={handleModelPopUp}
            handleDownlodingCSV={handleDownlodingCSV}
            handleDownlodingPDF={handleDownlodingPDF}
            customFilter={true}
            DownloadShowFile={true}
            DownloadShowPDF={1}
            DownloadShowCSV={2}
          />


          <CommonErrorAlert
            data={{
              apiopen: apiopen,
              apiErrorMsg: apierrorMsg,
              isIconStyled: false
            }}
            closeAlert={apihandleClose} />
        </div>
      </div>
    </>
  );
}
